import * as moment from 'moment';
import * as $ from 'jquery';

export function parseDate(d : string | undefined) : Date {
	return moment(d, 'YYYY-MM-DDTHH:mm:ssZ').toDate();
}

export function upper(str : string) : string {
	return String(str).toUpperCase();
}

declare global {
	interface Navigator {
		mockDoNotTrack : string;
		msDoNotTrack : string;
	}
}

/**
 * Compares numbers for sorting arrays ascending
 */
export function compareNumbers(a : number, b : number) {
	return a - b;
}

export const enum Segment {
	RES = 'res', // Residential
	SME = 'sme', // Small Business
	CBU = 'cbu', // Enterprise (ENT)
}


export function pageSegment() : Segment | undefined {
	const segment = String($(document.body).data('page-segment')).toLowerCase();
	switch(segment) {
		case Segment.SME:
		case Segment.RES:
			return segment;
		default:
			return undefined;
	}
}

export const enum Language {
	German = 'de',
	French = 'fr',
	Italian = 'it',
	English = 'en',
}

/**
 * Adds loaded and load methods for lazily-loaded components
 * @param loadFunction - the method doing the loading, must return a promise (most likely from $.ajax)
 * @param loadCallback - a callback that gets called when the promise has resolved, used to set correct state
 */
export abstract class Loadable<
	T, U,
	R = T
> {
	private jqPromise? : JQuery.Promise3<T, any, never, U, any, never, any, any, never>;
	private loader? : JQuery.Promise<R>;

	public loaded() : boolean {
		return !!this.loader && this.loader.state() === 'resolved';
	}
	public load() : JQuery.Promise<R> {
		if (this.jqPromise && this.jqPromise.state() !== 'rejected') {
			// Currently loading or sucessfully loaded => return promise
			return this.loader!.promise();
		}
		// Either not yet loaded or already failed
		const deferred = $.Deferred<R>();
		this.jqPromise = this.loadFunction().done((t : T, u : U) => {
			deferred.resolve(this.loadCallback(t, u));
		});
		this.loader = deferred.promise();

		return this.loader;
	}

	protected abstract loadFunction() : JQuery.Promise3<T, any, never, U, any, never, any, any, never>;
	protected abstract loadCallback(t : T, u : U) : R;
}

export type SimpleXHR = JQuery.Promise3<
	any[], JQuery.jqXHR<any[]>, never,
	JQuery.Ajax.SuccessTextStatus, JQuery.Ajax.ErrorTextStatus, never,
	JQuery.jqXHR<any[]>, string, never
>;


export const enum Case {
	Retention = 'RETENTION',
	Activation = 'ACTIVATION',
	New = 'NEW',
	Renew = 'RENEW',
	Takeover = 'TAKEOVER',
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/ecommerce/util.ts